import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@app/service/user-service/user.service';
import {
  CheckoutStatus,
  StateService,
} from 'src/app/service/state/state.service';
import { RouteComponent } from '../../route.component';
import { Location } from '@angular/common';
import { HeaderService } from '@app/service/header/header.service';
import { DeviceDetectorService, OS } from 'ngx-device-detector';

@Component({
  selector: 'app-de-phone-verification',
  templateUrl: './de-phone-verification.component.html',
  styleUrls: [
    '../../page-shared.css',
    './de-phone-verification.component.scss',
  ],
})
export class DePhoneVerificationComponent
  extends RouteComponent
  implements OnInit
{
  loading = true;
  phoneNumberString: string;
  navigationInProgress = false;
  resendCodeInProgress = false;
  showError = false;
  verificationCode: string;
  validVerificationCodeFormat: boolean;
  isMobile: boolean;
  IOS: boolean;

  otpLength = 4;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private userService: UserService,
    private location: Location,
    private deviceDetectorService: DeviceDetectorService
  ) {
    super(router, route, stateService, headerService);
  }

  onOtpChange(e: any) {
    this.showError = false;
    this.verificationCode = e;
    this.validVerificationCodeFormat = e.length === this.otpLength;
    if (this.validVerificationCodeFormat) {
      this.handleCtaClick();
    }
  }

  ngOnInit(): void {
    if (
      this.state.status === CheckoutStatus.CANCELLED ||
      this.state.status === CheckoutStatus.EXPIRED
    ) {
      return;
    }
    this.isMobile = this.deviceDetectorService.isMobile();
    this.IOS = this.deviceDetectorService.getDeviceInfo().os === OS.IOS;
    this.getinfo();
  }

  back() {
    this.location.back();
  }

  async getinfo(): Promise<void> {
    try {
      const userInfo = await this.userService.getActiveUserInfoDe();
      const phoneNumber = userInfo.phoneNumber.value;
      this.phoneNumberString = `******${phoneNumber.slice(-4)}`;
      this.loading = false;
    } catch (err) {
      this.handleError(err);
    }
  }

  async reSendCode(): Promise<void> {
    if (this.resendCodeInProgress) {
      return;
    } else {
      try {
        this.resendCodeInProgress = true;
        await this.userService.resendPhoneVerificationSms();
        this.resendCodeInProgress = false;
      } catch (err) {
        this.resendCodeInProgress = false;
        this.handleError(err);
      }
    }
  }

  async verifyCode(): Promise<void> {
    try {
      const resp = await this.userService.verifyPhone(
        (this.verificationCode && this.verificationCode.trim()) || ''
      );
      if (resp.success) {
        await this.navigate();
      } else {
        this.showError = true;
      }
    } catch (err) {
      this.handleError(err);
    }
  }

  async handleCtaClick() {
    this.resetError();
    if (this.navigationInProgress || !this.validVerificationCodeFormat) {
      this.showError = true;
    } else {
      this.navigationInProgress = true;
      await this.verifyCode();
    }
    this.navigationInProgress = false;
  }
}
